import type { LandingPageContent } from '../types'

export const SOLICITAR_PRESUPUESTO_FOTOVOLTAICO: LandingPageContent = {
  slug: 'solicitar-presupuesto-fotovoltaico',
  lang: 'es',
  topicId: 'photovoltaik-anfrage-erstellen',
  title: 'Solicitar presupuesto fotovoltaico – en minutos y gratis',
  metaDescription:
    'Cree en pocos minutos una solicitud fotovoltaica anónima: suba fotos del tejado, las empresas ' +
    'ofertan y usted decide.',
  keywords: [
    'solicitar presupuesto fotovoltaico',
    'pedir presupuesto placas solares',
    'solicitud instalación fotovoltaica',
    'pedir oferta fotovoltaica',
  ],
  eyebrow: 'Listo en pocos minutos',
  h1: 'Cree su solicitud fotovoltaica en pocos minutos',
  intro:
    'En lugar de rellenar formularios en varios proveedores por separado, en Roofora crea una única ' +
    'solicitud anónima - y varias empresas instaladoras ofertan sobre ella. Aquí ve qué necesita para ' +
    'ello y qué ocurre después.',
  sections: [
    { type: 'heading', text: 'Qué necesita para su solicitud' },
    {
      type: 'list',
      items: [
        'Algunas fotos del tejado (basta con fotos hechas con el móvil)',
        'Una foto de su cuadro eléctrico',
        'Orientación e inclinación del tejado, si las conoce',
        'Su consumo anual aproximado, opcionalmente incluyendo bomba de calor o coche eléctrico',
      ],
    },
    { type: 'heading', text: 'Así calcula Roofora el tamaño adecuado de su instalación' },
    {
      type: 'paragraph',
      text:
        'A partir de sus datos, el sistema determina automáticamente una configuración de instalación ' +
        'adecuada - tamaño y potencia, ajustados a su tejado y su consumo. Usted no necesita ' +
        'conocimientos técnicos previos.',
    },
    { type: 'heading', text: 'Qué ocurre después de crear la solicitud' },
    {
      type: 'paragraph',
      text:
        'Su solicitud se publica de forma anónima - las empresas instaladoras de su región ven los ' +
        'datos del tejado y el consumo, pero no sus datos de contacto. Tienen entre 2 y 4 semanas para ' +
        'presentar presupuestos sin compromiso, que aparecen ordenados por precio para usted.',
    },
    { type: 'heading', text: 'Sus datos permanecen protegidos hasta que usted lo autorice' },
    {
      type: 'paragraph',
      text:
        'Solo cuando usted autoriza individualmente a una empresa instaladora concreta se comparten el ' +
        'correo electrónico y el teléfono - sin autorización colectiva para todas las que muestren ' +
        'interés. Para la cuenta solo necesita un nombre de usuario y una contraseña, sin correo ' +
        'electrónico.',
    },
  ],
  primaryCta: { label: 'Crear la solicitud gratis ahora', action: 'customer' },
  secondaryCta: { label: 'Ver antes los costes estimados', action: 'link', href: '/coste-instalacion-fotovoltaica' },
  relatedLinks: [
    { label: 'Cómo funciona la comparación de presupuestos', href: '/comparar-presupuestos-fotovoltaicos' },
    { label: 'Encontrar instalador fotovoltaico', href: '/encontrar-instalador-fotovoltaico' },
    { label: 'Planificar la instalación paso a paso', href: '/planificar-instalacion-fotovoltaica' },
  ],
}
